import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-csrsport',
  templateUrl: './csrsport.component.html',
  styleUrls: ['./csrsport.component.css'],
})
export class CSRSportComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
